import React, { useEffect, useState } from 'react';
import Modal from '../components/Modal/Modal';
import AddTripType from '../components/AddTripTypes/AddTripType';
import ApiManager from '../ApiManager/ApiManager';

const TripTypeFields = [
    { label: 'Type', name: 'type', type: 'picklist', required: true, options: ['hr-km', 'day-km']},
    { label: 'Name', name: 'name', type: 'text', required: true},
    { label: 'Description', name: 'description', type: 'text', required: true},
    { label: 'Hours', name: 'hours', type: 'number', required: true},
    { label: 'Days', name: 'days', type: 'number', required: true},
    { label: 'KM', name: 'km', type: 'number', required: true},
    { label: 'Point-to-Point (P2P)', name: 'is_p2p', type: 'checkbox', required: true },
];

const NewTripType = ({onSuccess}) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedType, setSelectedType] = useState('');

    const toggleModal = () => {
        setModalOpen(!isModalOpen);
        setSelectedType('');
    };

    const handleTypeChange = (type) => {
        setSelectedType(type);
        console.log("Selected Type: "+selectedType);
    };

    const fieldsForType = {
        'hr-km': ['type', 'name', 'description', 'hours', 'km', 'is_p2p'],
        'day-km': ['type', 'name', 'description', 'days', 'km', 'is_p2p'],
        default: ['type', 'name', 'description', 'is_p2p'],
    };
    
    const getFormFields = () => {
        const fieldsToShow = fieldsForType[selectedType] || fieldsForType.default;
        return TripTypeFields.filter(field => fieldsToShow.includes(field.name));
    };

    return (
        <div>
                <button className="custom-button" onClick={toggleModal}>
                    New Trip Type
                </button>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <AddTripType
                    toggleFunction={toggleModal}
                    title="Add Trip Type" 
                    formFields={getFormFields()}
                    apiFunction={ApiManager.addTripType}
                    onTypeChange={handleTypeChange}
                    selectedType={selectedType}
                    onSuccess={onSuccess}
                />
            </Modal>
        </div>
    );
};

export default NewTripType;
